var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[
    'section',
    { 'section--full-height' : _vm.fullHeight },
    { 'section--no-padding' : _vm.noPadding },
    { 'section--full' : _vm.fullWidth }
]},[(_vm.title)?_c('h1',{staticClass:"section__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }